import { column, Schema, Table } from '@powersync/web';

const orders = new Table(
  {
    bill_number: column.integer,
    table_id: column.integer,
    outlet_id: column.text,
    date: column.text,
    status_id: column.integer,
    waiter_id: column.text,
    client_id: column.text,
    mode: column.text,
    is_bill_printed: column.integer,
    created_by: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { outlet_status: ['outlet_id', 'status_id'] } },
);

const outlet_order_counters = new Table({
  last_bill_number: column.integer,
  updated_at: column.text,
});

const outlet_kot_counters = new Table({
  last_kot_id: column.integer,
  updated_at: column.text,
});

const outlet_sections = new Table(
  {
    outlet_id: column.text,
    name: column.text,
    is_hidden: column.integer,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet: ['outlet_id'] } },
);

const users = new Table(
  {
    email: column.text,
    first_name: column.text,
    last_name: column.text,
    role: column.text,
    company_id: column.text,
    outlet_id: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet: ['outlet_id', 'role'] } },
);

// section_id stored as TEXT — PowerSync aliases SERIAL PKs as TEXT strings
// ("5", "12", …). Keep as text to match the JOIN in ORDER_SELECT:
//   ot.section_id = os.id  (both TEXT)
const outlet_tables = new Table(
  {
    section_id: column.text,
    name: column.text,
    is_hidden: column.integer,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_section: ['section_id'] } },
);

const order_items = new Table(
  {
    order_id: column.text,
    menu_item_id: column.text,
    quantity: column.text,
    unit_price: column.text,
    amount: column.text,
    notes: column.text,
    status: column.text,
    kot_id: column.integer,
    physical_kot_number: column.text,
    physical_kot_recorded_by: column.text,
    added_by: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_order: ['order_id', 'status'] } },
);

const order_settlements = new Table(
  {
    order_id: column.text,
    amount: column.text,
    payment_method_id: column.integer,
    notes: column.text,
    created_by: column.text,
    created_at: column.text,
  },
  { indexes: { by_order: ['order_id'] } },
);

const discounts = new Table(
  {
    order_id: column.text,
    amount: column.text,
    added_by: column.text,
    notes: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_order: ['order_id'] } },
);

const item_cancellations = new Table(
  {
    menu_item_id: column.text,
    cancelled_by: column.text,
    reason: column.text,
    order_id: column.text,
    created_at: column.text,
  },
  { indexes: { by_order: ['order_id'] } },
);

const departments = new Table(
  {
    outlet_id: column.text,
    name: column.text,
    address: column.text,
    status: column.text,
    kot_enabled: column.integer,
    display_order: column.integer,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet: ['outlet_id', 'status'] } },
);

const menu_categories = new Table(
  {
    outlet_id: column.text,
    name: column.text,
    description: column.text,
    display_order: column.integer,
    status: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet: ['outlet_id', 'status'] } },
);

const menu_items = new Table(
  {
    outlet_id: column.text,
    category_id: column.text,
    department_id: column.text,
    name: column.text,
    description: column.text,
    base_price: column.text,
    image_url: column.text,
    sku: column.text,
    status: column.text,
    display_order: column.integer,
    is_taxable: column.integer,
    tax_rate: column.text,
    fiscal_tax_category_id: column.text,
    ebm_item_cd: column.text,
    ebm_item_cls_cd: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet_cat: ['outlet_id', 'category_id', 'status'] } },
);

const clients = new Table(
  {
    company_id: column.text,
    first_name: column.text,
    last_name: column.text,
    email: column.text,
    contact: column.text,
    address: column.text,
    tin_number: column.text,
    menu_percentage_rate: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_company: ['company_id'] } },
);

const outlet_printers = new Table(
  {
    outlet_id: column.text,
    name: column.text,
    printer_identifier: column.text,
    connection_type: column.text,
    ip_address: column.text,
    port: column.integer,
    paper_size: column.text,
    details: column.text,
    is_active: column.integer,
    created_by: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet: ['outlet_id', 'is_active'] } },
);

const section_printer_mappings = new Table(
  {
    outlet_id: column.text,
    section_id: column.text,
    printer_id: column.text,
    operation: column.text,
    department_id: column.text,
    created_by: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet_section: ['outlet_id', 'section_id', 'operation'] } },
);

const takeaway_printer_mappings = new Table(
  {
    outlet_id: column.text,
    device_id: column.text,
    printer_id: column.text,
    operation: column.text,
    department_id: column.text,
    created_by: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet_device: ['outlet_id', 'device_id', 'operation'] } },
);

const payment_methods = new Table({
  name: column.text,
  ebm_payment_type_code: column.text,
  created_at: column.text,
});

const registered_devices = new Table(
  {
    outlet_id: column.text,
    device_fingerprint: column.text,
    device_name: column.text,
    operating_system: column.text,
    is_enabled: column.integer,
    created_at: column.text,
  },
  { indexes: { by_outlet: ['outlet_id'] } },
);

// Kitchen Display Screen: one row per (order_id, kot_id, department_id).
// order_date is denormalized (not joined through orders) so the sync stream
// can scope to the outlet's current open business day directly — see
// powersync.yaml's kitchen_display stream comment for why.
const kitchen_tickets = new Table(
  {
    order_id: column.text,
    outlet_id: column.text,
    kot_id: column.integer,
    department_id: column.text,
    order_date: column.text,
    status: column.text,
    created_at: column.text,
    in_prep_at: column.text,
    qc_at: column.text,
    ready_at: column.text,
    served_at: column.text,
    updated_by: column.text,
    updated_at: column.text,
  },
  {
    indexes: {
      by_outlet_date: ['outlet_id', 'order_date'],
      by_outlet_status: ['outlet_id', 'status'],
    },
  },
);

// Append-only audit trail: one row per kitchen_tickets status transition.
const kitchen_ticket_status_history = new Table(
  {
    ticket_id: column.text,
    outlet_id: column.text,
    order_date: column.text,
    from_status: column.text,
    to_status: column.text,
    changed_by: column.text,
    changed_at: column.text,
  },
  { indexes: { by_ticket: ['ticket_id'] } },
);

// EBM/fiscal setup: non-secret projection of outlet_ebm_configs — the
// hosted_api_key_ciphertext column is deliberately never listed in
// powersync.yaml's ebm_setup stream and so never appears here.
const outlet_ebm_configs = new Table(
  {
    outlet_id: column.text,
    deployment_mode: column.text,
    vsdc_base_url: column.text,
    tin: column.text,
    bhf_id: column.text,
    dvc_srl_no: column.text,
    activation_status: column.text,
    last_init_result_cd: column.text,
    last_init_at: column.text,
    last_health_check_at: column.text,
    last_health_ok: column.integer,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet: ['outlet_id'] } },
);

// Fiscal receipt/settlement status: outlet_id is denormalized directly on
// this table (not joined through orders) for the same reason kitchen_tickets
// is — see that table's comment above and powersync.yaml's fiscal_status
// stream comment.
const ebm_sale_records = new Table(
  {
    outlet_id: column.text,
    order_id: column.text,
    order_date: column.text,
    invc_no: column.integer,
    submission_status: column.text,
    rcpt_no: column.text,
    tot_rcpt_no: column.integer,
    rcpt_ty_cd: column.text,
    sdc_id: column.text,
    mrc_no: column.text,
    rcpt_sign: column.text,
    intrl_data: column.text,
    vsdc_rcpt_pbct_date: column.text,
    result_cd: column.text,
    error_message: column.text,
    override_by_user_id: column.text,
    override_reason: column.text,
    requires_reprint: column.integer,
    submitted_at: column.text,
    confirmed_at: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_outlet: ['outlet_id'], by_order: ['order_id'] } },
);

const outlet_ebm_invoice_counters = new Table({
  last_invc_no: column.integer,
  updated_at: column.text,
});

const fiscal_tax_categories = new Table({
  country_iso: column.text,
  code: column.text,
  name: column.text,
  default_rate: column.text,
  is_default: column.integer,
  is_active: column.integer,
  display_order: column.integer,
});

export const AppSchema = new Schema({
  orders,
  outlet_order_counters,
  outlet_kot_counters,
  outlet_sections,
  users,
  outlet_tables,
  order_items,
  order_settlements,
  discounts,
  item_cancellations,
  departments,
  menu_categories,
  menu_items,
  clients,
  outlet_printers,
  section_printer_mappings,
  takeaway_printer_mappings,
  payment_methods,
  registered_devices,
  kitchen_tickets,
  kitchen_ticket_status_history,
  outlet_ebm_configs,
  ebm_sale_records,
  outlet_ebm_invoice_counters,
  fiscal_tax_categories,
});
